module.exports = require('./dist/core');



//////////////////
// WEBPACK FOOTER
// ./node_modules/leancloud-realtime/core.js
// module id = J5N6
// module chunks = 0